import * as styles from "./Loader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { LoaderProps } from "./Loader.types";

export function Loader({
  variant = "bar",
  size,
  currentColor,
  label = "Loading",
  className,
  ...props
}: LoaderProps): JSX.Element {
  return (
    <span
      data-slot="loader"
      role="status"
      aria-label={label}
      className={clsx(
        styles.loader({ variant, size, currentColor }),
        className,
      )}
      {...props}
    >
      {variant === "bar" ? (
        <span className={styles.indicator} />
      ) : (
        [0, 1, 2].map((index) => <span key={index} className={styles.dot} />)
      )}
    </span>
  );
}
